export const health = [
    {
        id: "content-health-trending",
        name: "الشائع",
        articles: [
            {
                id: "b5d84dfb-d80f-4ba1-ab4e-c33e255b3157",
                class: "columns-3-balanced",
                header: "تركيز كامل للذهن",
                url: "#",
                image: {
                    src: "assets/images/benjamin-child-rOn57CBgyMo-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "مينيابوليس لوريم حتى كتلة سابين الحلق.",
                type: "list",
                content: [
                    {
                        id: "ee44b675-85c6-4aa7-9ce5-5b37311297bb",
                        content: "كرة القدم إنفاذ القبيح سعر الجيش الياسمين.معرف الصلصة المعقمة بواسطة صلصة.",
                    },
                    {
                        id: "a40135ff-bc16-4a53-b6b1-d25835703af4",
                        content: "الثانية ثم تحت, أن تحرّك حادثة بحق, وجزر الأخذ استرجاع",
                    },
                    {
                        id: "d143d9d9-7c3f-4b36-ad47-f591783f1595",
                        content: "الجوي و. وصغار ليبين وتم من, أسر هو مسارح الفترة العالم،. ضمنها إيطاليا لم وتم, ",
                    },
                    {
                        id: "e89bebb4-484b-45f2-a87b-409a941436da",
                        content: "الجوع والقبيح.يحتاج كتلة الطفل إلى كتلة من الرسوم المتحركة الفلفل الحار.",
                    },
                ],
            },
            {
                id: "a1822776-68b2-4d24-95e2-917756de0c12",
                class: "columns-3-balanced",
                header: "أحدث الأبحاث",
                url: "#",
                image: {
                    src: "assets/images/louis-reed-pwcKF7L4-no-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "ومع ذلك ، فهو يريد أعضاء كرة القدم مثل حياة سلطة كرة القدم.",
                type: "list",
                content: [
                    {
                        id: "d71c34e3-6c8e-4097-92a4-efd8042a192e",
                        content: "عرض نقطة والمعدات عن. جديدة الأهداف الإثنان حتى بـ, يتم ثمّة كرسي.",
                    },
                    {
                        id: "e0ab9000-9eea-4f64-b6d2-9f5e1250c0f9",
                        content: "لأمريكية بل, تكتيكاً الربيع، بين و. إحكام الأوروبية عن مدن",
                    },
                    {
                        id: "66f25618-e649-4814-a546-6edcc036dcfe",
                        content: "عن أواخر إستعمل الطريق وصل. قد وحرمان بمباركة والمعدات جُل",
                    },
                    {
                        id: "7b68e99a-151f-4452-99c9-49be9b399c2a",
                        content: "ثمّة أساسي الاندونيسية أم هذه. اسبوعين الإمداد الجنوبي بحق عن.",
                    },
                ],
            },
            {
                id: "0a522480-9f37-43e3-bbf2-c5398450a921",
                class: "columns-3-balanced",
                header: "صحية كبار",
                url: "#",
                image: {
                    src: "assets/images/esther-ann-glpYh1cWf0o-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "لا يتم تعزيز الشوكولاتة من قبل.",
                type: "list",
                content: [
                    {
                        id: "1cb48e86-99fd-44f8-9ce6-016778eb35d2",
                        content: "تنورة الأداء الكراهية في أي ابتسامة ولكن الكراهية الجذابة.لا يحتاج إلى أي ميدليسي أيضًا.",
                    },
                    {
                        id: "fa57210c-bd31-4f4a-a601-9f3546196b4f",
                        content: "نفسها لوصف اللاعبين أو الدفع.ما لم تتلقى الحياة أكبر قطر في المنطقة.",
                    },
                    {
                        id: "e6e75564-56e0-4f87-9169-89f2820f7221",
                        content: "الشطر من, كردة تسبب الإتحاد في كلا. أم ليس الأعضاء أو الأعضاء.",
                    },
                    {
                        id: "243d7680-08ba-41d8-bff5-b544667064e5",
                        content: "في قطر عطلة نهاية الأسبوع كمنطقة معقمة في كرة القدم الخوف.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-health-latest-facts",
        name: "أحدث الحقائق",
        articles: [
            {
                id: "db2abfd6-b4d4-4237-850a-7f34de938739",
                class: "columns-3-balanced",
                header: "المزيد من الحياة ، ولكن أفضل",
                image: {
                    src: "assets/images/melissa-askew-8n00CqwnqO8-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "ولكن الوقت وعاء والارتجال الكتلة كتلة الكتل.",
                type: "list",
                content: [
                    {
                        id: "92f15b5f-f191-4636-b197-b65b2fead08f",
                        content: "جعبة أو التذاكر تحتاج الآن.كرة القدم ومن من السادس وصفة شبكة.",
                    },
                    {
                        id: "fe2aad93-2770-4068-aec3-ed5d630e47ec",
                        content: "إيو علاقة الوراء, بقيادة الشتوية إيو في. حالية التخطيط تم بعض. اكتوبر وحلفاؤها وبريطانيا دن",
                    },
                    {
                        id: "0f098b80-ec85-4de3-b0d4-4288947febaa",
                        content: "اضي للأراضي أن, ان بلاده وتنامت مما. بعد في مليون استبدال الإنذار،, لان مع",
                    },
                ],
            },
            {
                id: "8cfeff8c-94cb-4eca-b5e2-b4214b761705",
                class: "columns-3-balanced",
                header: "في حال فوته على نفسك",
                image: {
                    src: "assets/images/marcelo-leal-6pcGTJDuf6M-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "أرنب سعر جعبة كبيرة.",
                type: "text",
                content:
                    "عُقر الجديدة، الأوروبيّون في فقد, لم سقوط أوزار بتحدّي دار. بحق و استبدال وفنلندا, قِبل أخرى الوزراء عن وفي. في وباءت بالرغم ويكيبيديا دون, من لها أطراف إتفاقية. إذ جهة الشرق، بالولايات. عل عدد اوروبا لليابان, قبل أحكم السبب الأولى و. ثم فصل للحكومة الإتفاقية الاندونيسية, في حيث قامت تشكيل وحلفاؤها.\n\nحين حالية الحكم وانهاء و, ان فبعد الغالي وقد, عل حول وكسبت للأراضي. لمّ حقول والكوري استعملت ثم, ثم ذلك اللا بوابة الأرضية, شرسة جسيمة تصرّف تعد ثم. يتم إذ الآلاف شموليةً, مع فقد وبعض كردة الأثنان. لهذه غريمه بال لم. مما في الشّعبين ويكيبيديا. وقام سليمان، البولندي بل أخر.",
            },
            {
                id: "ae3f3c45-b7fe-4729-8374-f3ba8d11eeff",
                class: "columns-3-balanced",
                header: "الفضاء والعلوم",
                image: {
                    src: "assets/images/nasa-cIX5TlQ_FgM-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "قد, و شعار وبريطانيا حدى. فصل ما لفشل جديداً, قد أمام ",
                type: "list",
                display: "bullets",
                content: [
                    {
                        id: "31fa8504-b3e7-4f33-bce6-d5e63c0e5c36",
                        content: "وبعض المتساقطة، الإقتصادية من مما, مع بحشد مليون إحكام بعض.",
                        url: "#",
                    },
                    {
                        id: "c86d479a-2603-4b7e-9f8e-c6c2482f1600",
                        content: "ضرب مايو والتي من. عشوائية الجنرال دار ما, جُل المدن انتصارهم إذ.",
                        url: "#",
                    },
                    {
                        id: "3793f895-bcf1-4213-91a9-8efb79395dbc",
                        content: "بعد مع وقام تكبّد الإمتعاض, حين دأبوا وكسبت من.",
                        url: "#",
                    },
                    {
                        id: "8da08881-849b-4a8c-8890-89c56028c6cd",
                        content: "الأرض كما هو. وفي أوسع أوروبا ليرتفع ٣٠, بـ ومن هامش لأداء",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-health-medical-breakthroughs",
        name: "الاختراقات الطبية",
        articles: [
            {
                id: "2afaf4ee-4d1c-4f54-a970-bc8222cc3090",
                class: "columns-3-wide",
                header: "الاختراعات الجراحية",
                url: "#",
                image: {
                    src: "assets/images/national-cancer-institute-A2CK97sS0ns-unsplash_684.jpg",
                    alt: "عنصر نائب",
                    width: "684",
                    height: "385",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                    tag: {
                        type: "breaking",
                        label: "كسر",
                    },
                },
                title: "هو الكثير من الوقت لفترة طويلة جدا.بالطبع بحاجة الآن إلى كرتون الشوكولاتة موريس في البيئة المنحدرة.",
                type: "text",
                content:
                    "عرض أن ألمّ وكسبت, مع يتمكن الجنوب التجارية مما, أم وبعد اللا والقرى دول. دول مكّن الصفحات والفرنسي أم, بحق ٣٠ شاسعة أسابيع معزّزة, دارت الشهيرة على بـ. قد المسرح أوروبا الضروري وقد, شدّت للحكومة حول كل. أما حاول أثره، الإطلاق قد. يتم عن الحكم المحيط مقاومة.",
            },
            {
                id: "7213a42c-c2eb-486a-bb2e-b59f6667fb4a",
                class: "columns-3-narrow",
                header: "الرعاية الطبية",
                url: "#",
                image: {
                    src: "assets/images/national-cancer-institute-NFvdKIhxYlU-unsplash_336.jpg",
                    alt: "عنصر نائب",
                    width: "336",
                    height: "189",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "غدا دائما هوثتور أو الحياة.أو قبيح الآن بحاجة إلى ألم لوريم ولكن اسحب نفسك الآن.",
                type: "text",
                content:
                    "غير بفرض إستعمل ليتسنّى ٣٠, كلّ ديسمبر بالمطالبة ثم. أم تعداد لأداء العالمية الى, هنا؟ أسيا وبالرغم أضف في. تسمّى فهرست باستخدام هذه أي, عن حين غضون مدينة أعلنت, إحتار التجارية الا بل. من رئيس واُسدل شيء, بشكل شمال بشرية بـ جُل, عدم ألمّ الأمم العظمى في. أوسع الستار إتفاقية ذلك أن, في أضف تصفح اكتوبر ابتدعها, ما كلّ لفرنسا وبريطانيا. حول إبّان بتحدّي لبولندا، ما, إذ حيث أراض الربيع، الواقعة. بعد هو الجو نهاية المارق, مكثّفة مقاومة ٣٠ وتم.",
            },
            {
                id: "9323f56f-d3b3-4b86-bd4c-014392b62272",
                class: "columns-3-narrow",
                header: "دواء",
                url: "#",
                image: {
                    src: "assets/images/myriam-zilles-KltoLK6Mk-g-unsplash_336.jpg",
                    alt: "عنصر نائب",
                    width: "336",
                    height: "189",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "الج المطور الجامعي.إنه يرغب في عدم تعزيز الشوكولاتة فيها.",
                type: "text",
                content:
                    "عدم وشعار وحلفاؤها مع, حالية واحدة و كان, قامت فرنسا الأجل لم هذا. عدد عل وباءت الإنذار، التغييرات, عجّل أفاق به، هو, وصل بحشد بقسوة و. في اللا اسبوعين الصينية أسر, تشكيل وتزويده اسبوعين ثم عدد. بل دار شدّت أسيا المشتّتون, فقد ما شعار أدنى, لكون ممثّلة يبق في. قامت الغالي العناد لم نفس, مع وتم ليرتفع واشتدّت والنفيس.",
            },
        ],
    },
    {
        id: "content-health-latest-videos",
        name: "أحدث مقاطع الفيديو",
        articles: [
            {
                id: "c1f811ca-284b-4e7b-9bfb-bb5a7c72211d",
                class: "columns-1",
                type: "grid",
                content: [
                    {
                        id: "f0e9befa-3d54-4a26-8267-0e38bb0eaa49",
                        image: {
                            src: "assets/images/mufid-majnun-J12RfFH-2ZE-unsplash_684.jpg",
                            alt: "عنصر نائب",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "يشاهد",
                            },
                        },
                    },
                    {
                        id: "e301a866-edd4-47a4-a4a6-ce4035c2ab74",
                        image: {
                            src: "assets/images/irwan-rbDE93-0hHs-unsplash_684.jpg",
                            alt: "عنصر نائب",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "يشاهد",
                            },
                        },
                    },
                    {
                        id: "329f6075-3a95-4a20-b3e1-ade5734544b4",
                        image: {
                            src: "assets/images/hyttalo-souza-a1p0Z7RSkL8-unsplash_684.jpg",
                            alt: "عنصر نائب",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "يشاهد",
                            },
                        },
                    },
                    {
                        id: "50b6d145-34da-4a7a-8f3f-bb1674a7692b",
                        image: {
                            src: "assets/images/jaron-nix-7wWRXewYCH4-unsplash_684.jpg",
                            alt: "عنصر نائب",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "يشاهد",
                            },
                        },
                    },
                ],
            },
        ],
    },
    {
        id: "content-health-educational",
        name: "تعليمية",
        articles: [
            {
                id: "c2dc8f88-8a0a-4a3f-aadd-a5f83e291081",
                class: "columns-1",
                type: "grid",
                display: "grid-wrap",
                content: [
                    {
                        id: "994fb978-2024-4c58-a1e8-f19e8493c703",
                        image: {
                            src: "assets/images/bruno-nascimento-PHIgYUGQPvU-unsplash_448.jpg",
                            alt: "عنصر نائب",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "كلّ أن الخاطفة بالرّغم بريطانيا،, الشتاء الشهيرة ان هذا, حقول وإقامة كلّ مع. وبدون المضي الإقتصادية عرض هو. لم العدّ مهمّات أوروبا مما. أي وتم التي الأجل سبتمبر, الى ما فكانت مساعدة. مع الشهير والديون اقتصادية يبق.",
                        url: "#",
                    },
                    {
                        id: "4c2254af-2e9a-4249-a467-112211c41698",
                        image: {
                            src: "assets/images/brooke-lark-lcZ9NxhOSlo-unsplash_448.jpg",
                            alt: "عنصر نائب",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "ببعض ولاتّساع جهة أي, إذ الحكومة الإمداد غير. أضف لم كانت تصرّف وفرنسا, عل شمال منتصف الجنوبي تعد. كما ثم وفنلندا الحكومة, تلك و اسبوعين إتفاقية التقليدي. غريمه الأسيوي بل يكن, لان شدّت قِبل واندونيسيا، ان, يبق أعمال مواقعها باستخدام كل. لفشل أمام الإمداد أن وقد, حدى وبعض تسمّى منتصف هو. الأراضي البولندي الأمريكية فقد في, ومن و الأولى ابتدعها.",
                        url: "#",
                    },
                    {
                        id: "a49d65ba-d42c-4b35-8926-479a8988d232",
                        image: {
                            src: "assets/images/kelly-sikkema-WIYtZU3PxsI-unsplash_448.jpg",
                            alt: "عنصر نائب",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "جُل بل تحرّك استعملت. فقد الولايات الإنذار، من, مرمى فمرّ الطرفين ان دنو. للجزر الفترة عن الا, ثم اعلان اليابان، أخر. بل ويعزى ولاتّساع وتم, وقد أي عرفها انتباه. ٣٠ هذه قائمة واُسدل, حتى فقامت ألمانيا مع.",
                        url: "#",
                    },
                    {
                        id: "c6f55f29-6b48-433d-85d1-0c952a01fa00",
                        image: {
                            src: "assets/images/robina-weermeijer-Pw9aFhc92P8-unsplash_448.jpg",
                            alt: "عنصر نائب",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "تم رئيس أفاق ولم, فعل هو سكان الأوروبية. وجهان العظمى هو كان, إذ دنو الأولى لليابان العمليات. يتسنّى بتطويق الصفحات يكن هو. بعض مئات ونتج اتّجة بل, بل ببعض الأرضية بين. مع تجهيز وتنصيب واستمرت شيء, يتمكن السيطرة مع دار.",
                        url: "#",
                    },
                    {
                        id: "720a4102-5a8f-4825-ae68-e1d21a69d71a",
                        image: {
                            src: "assets/images/sj-objio-8hHxO3iYuU0-unsplash_448.jpg",
                            alt: "عنصر نائب",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "المضي للسيطرة لبلجيكا، هو الا, تم لها قادة يتعلّق, الثقيل لتقليعة استمرار كلّ و. لها الأولى الصينية بمعارضة عل, غرّة، وقامت عل بحث. ضرب الدمج تاريخ السفن قد, العالمي وقدّموا حيث هو. يكن ثم لغزو استمرار بالتوقيع, مئات وحتى مع مدن. يقوم يتسنّى سليمان، بـ دنو.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-health-fitness",
        name: "لياقة بدنية",
        articles: [
            {
                id: "4e6716eb-0430-49b0-9d95-352333d760a0",
                class: "columns-wrap",
                header: "حرق السعرات الحرارية الخاصة بك",
                type: "excerpt",
                content: [
                    {
                        id: "930209e6-9f95-49c2-b5e7-1b4b8024fc8b",
                        image: {
                            src: "assets/images/scott-webb-U5kQvbQWoG0-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "مدن عل جنوب الجوي, عل جدول لتقليعة التجارية عدم. بين ٣٠ علاقة تكتيكاً. يرتبط وأكثرها تم كلا, الا مارد دأبوا العالم ثم. وترك غرّة، بلديهما أخذ قد, هو وبعدما الخاسر كان. تم الى أطراف الحكومة. حتى أي أمّا بهيئة الإطلاق.",
                    },
                    {
                        id: "85789d48-e369-43a0-998c-5cc9af9256eb",
                        image: {
                            src: "assets/images/sven-mieke-Lx_GDv7VA9M-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "حقول الأولى إذ إيو, معقل الشمال وصل لم. قد وتم ميناء الأولى العالمية, ان حادثة واُسدل انه. ودول قررت الواقعة حول عل. أسر ما وعُرفت للسيطرة, جدول تحرير كلّ لم. يبق أفريقيا الأرضية قد, ثم جدول واُسدل دون.",
                    },
                    {
                        id: "a8c8607f-8178-4b37-954a-d1578ae6624a",
                        image: {
                            src: "assets/images/geert-pieters-NbpUM86Jo8Y-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "استدعى مساعدة ديسمبر حول بل, تلك هو السفن واعتلاء بريطانيا،, أن بشرية الأمريكية ومن. فرنسا اقتصادية الانجليزية بل كلا, أفاق للسيطرة كما في. تحت أي العناد تغييرات وهولندا،, بل بخطوط البرية عدد, عن والحزب معارضة وأكثرها شيء. عرفها وأزيز سبتمبر ان عرض. الأراضي المتاخمة بريطانيا-فرنسا مع بال.",
                    },
                ],
            },
            {
                id: "056698a8-0ac8-4342-9e67-25993d574866",
                class: "columns-wrap",
                header: "مفضلات الصالة الرياضية",
                type: "excerpt",
                content: [
                    {
                        id: "a43f2dd1-ac0d-4ba1-81ef-3fcaf359b5fc",
                        image: {
                            src: "assets/images/boxed-water-is-better-y-TpYAlcBYM-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "عدد انتصارهم الأوروبية ما, إذ انه بأيدي سليمان، وبولندا, بحث أم بوابة وايرلندا. أم دارت الثالث دول, الدول النفط وتنامت الا بـ, بشرية لأداء الساحة عل يكن. ما لمّ حقول إستعمل بولندا،, على قد وتتحمّل الإحتفاظ. من مما إختار لأداء العدّ, تسبب بداية عدد لم. وإيطالي المؤلّفة عل بال, بعض والتي الصعداء في, غير عن السفن الأوربيين.",
                    },
                    {
                        id: "67b4bee9-5248-45b5-98ed-aeadc2a33466",
                        image: {
                            src: "assets/images/jonathan-borba-lrQPTQs7nQQ-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "وتم من شاسعة يتمكن. هو عُقر الحكومة استراليا، حيث, تعد عقبت الصفحة اسبوعين بل. لم شيء وبداية التجارية, هو وقد جزيرتي شموليةً الأوروبي. للصين الضروري عل لها, نفس ثم الشتوية الأسيوي. وصل تم نتيجة الإطلاق. اتفاقية الدولارات ما أخذ, تطوير كنقطة العناد هو بال.",
                    },
                    {
                        id: "e182116f-dff8-4fcf-acb8-b7743e2cbdd2",
                        image: {
                            src: "assets/images/mr-lee-f4RBYsY2hxA-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "ساعة مسؤولية والديون ما لكل, وتم جسيمة والتي الإنذار، أي, حين من أوسع البشريةً التنازلي. ان هذه أدنى وبحلول. لأداء واتّجه لم هذه, أي هامش عرفها المنتصر عدم, قام بل وبالرغم الأرضية لبولندا،. لمّ عرفها غينيا بل, به، كرسي أعلنت تم. مارد بالحرب الحيلولة ٣٠ دون, إيو ليركز للجزر تحرّكت و.",
                    },
                ],
            },
            {
                id: "389c5495-b37c-423f-8950-a1845317e41c",
                class: "columns-wrap",
                header: "بيلاتيس",
                type: "excerpt",
                content: [
                    {
                        id: "7bd49e3d-06fc-4195-99bc-3f604de242b3",
                        image: {
                            src: "assets/images/ahmet-kurt-WviyUzOg4RU-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "قد الا جمعت حقول ويكيبيديا. لها حادثة التّحول ما. أم صفحة الخطّة الحكومة كما. مرجع غرّة، ما بحث, اوروبا الأثنان ومن و. بداية الثالث، يكن ما. عدد مع وبدون غينيا انتباه. كل نتيجة الأولى الشرقي يكن.",
                    },
                    {
                        id: "f41e3b74-a33d-4169-b604-099da64e24fb",
                        image: {
                            src: "assets/images/stan-georgiev-pvNxRUq7O7U-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "هناك تغييرات واشتدّت حيث في, شدّت للمجهود التجارية ومن ان, لم وسوء وأزيز الستار مكن. تحرّكت الإطلاق بمعارضة تحت لم, من وقد تجهيز الجنوبي. بعض وسفن أراض الأخذ أي, ليبين ويعزى أم دون. مكّن بهيئة وتنصيب هو كلا, وقرى الأوروبية، عن وصل.",
                    },
                    {
                        id: "5bc866c7-7d7e-44ef-bc98-4c68739be329",
                        image: {
                            src: "assets/images/ahmet-kurt-5BGg2L5nhlU-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "كلا أم أفاق ممثّلة ألمانيا, فعل تم تونس الشمل وتتحمّل, سكان التّحول جهة أي. تصفح دأبوا الأثناء، يبق لم, قد أخر الأمم وتزويده ماليزيا،, بال تم تزامناً وهولندا،. لم الحكم الطريق انه, لان أم هامش وأكثرها والديون. من بقسوة تجهيز حول. ليبين وقدّموا ويكيبيديا تم يتم, جعل أي وبولندا بمعارضة, بها أي واُسدل الأمريكية.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-health-guides",
        name: "خطوط إرشاد",
        articles: [
            {
                id: "9a1282a2-e227-4d96-8f3e-99c580f2939a",
                class: "columns-3-balanced",
                header: "الصحة بعد 50",
                type: "articles-list",
                content: [
                    {
                        id: "efcabc5f-f52d-47c4-9f94-8bd780882b7a",
                        title: "وكما أن الوصفة تسحب دائمًا للعلاج المجاني.",
                        content: "من تنفّس وتنامت الاندونيسية كما. ما لكل شدّت عشوائية, من جُل يعبأ قِبل. أي وصل وقوعها، اليابان. في ذات مرمى الثقيل الاندونيسية, فعل ما وجهان واحدة. و جعل القوى الكونجرس الأمريكية, ٣٠ تكتيكاً المعاهدات يكن.",
                    },
                    {
                        id: "2a62c03f-5073-424f-aab5-c0b7e25ae988",
                        title: "تتطلب شركة طيران الجزر أمراضًا ذكية أو ضحك القوس.",
                        content:
                            "وشعار النزاع في وصل, تم أطراف بقيادة وفنلندا بحث. اليها المواد كما ما. و بتطويق الربيع، انه. أم الدول وزارة فقامت بحق, بحث و حاول الدول باستخدام. عن أدوات الأسيوي انه, بل أساسي سليمان، تغييرات أسر, أم الأجل المتساقطة، يتم.",
                    },
                    {
                        id: "c8886351-2d3f-422c-a24e-85a3ac682673",
                        title: "ذلك الحرة لمحاكم الأهداف تم. ديسمبر الخاصّة الإثنان أس",
                        content: "حتى الساحل المجتمع أن, يعبأ فرنسية الشرقي ان لان, بل حول هنا؟ شدّت بخطوط. اللا تاريخ مليون أي وتم. أم شرسة الأمم دون, وبعض الأمور لمّ ان. دار مع رئيس أراض, إذ مدن موالية اليميني, شيء و واستمر البشريةً.",
                    },
                ],
            },
            {
                id: "7b268ec3-8ac2-42fc-ab0f-ac650d2493f1",
                class: "columns-3-balanced",
                header: "قلب صحي",
                type: "articles-list",
                content: [
                    {
                        id: "ee5dd7b7-30a1-48a9-92c4-9f605ec1d156",
                        title: "حامل مع شركائه ويسحب الأشعة ودفع كبير للجبال.",
                        content:
                            "بلا ببعض الشهيرة اللازمة أم. التغييرات الأوروبيّون لها قد, إيو أي خطّة غريمه فرنسية, بال قد ممثّلة المبرمة. حتى وشعار الموسوعة ما, مكن الصينية الإكتفاء أم. الأبرياء الأوروبية إيو في, ما حول وبعدما ليتسنّى بالإنزال. هذه عن الحكم بالرّد, تكبّد والتي به، لم, أن وسفن أجزاء مما. بال ترتيب وقامت تم, وحتّى لإعلان مسؤولية و عرض.",
                    },
                    {
                        id: "74b09799-d0be-4e52-9bb9-748cde4af833",
                        title: "ليس الكثير من الوقت فقط للجزر ، أيضًا ، الكثير من الوقت.",
                        content:
                            "ما وصل كردة وحلفاؤها, إذ كانت إعلان الثقيلة شيء. أمدها تشيكوسلوفاكيا بلا عن. بقعة الأولى الإقتصادية و حيث, وهولندا، التقليدي تم ذلك. الأحمر مهمّات ٣٠ كلّ. كلّ أوزار العالم من. يتم ومطالبة بالمحور في. إيو رجوعهم المتحدة بـ.",
                    },
                    {
                        id: "9e31db8f-9fba-4a1f-99f8-101e357802b4",
                        title: "الكثير من العلاج حتى القطر الجذاب للارتجاع.",
                        content: "اوروبا الأسيوي الولايات مع وقد, ما دنو عرفها أوروبا بأضرار. قام عن يعبأ عقبت وحرمان, و حلّت تحرّكت الا. هذه يذكر ٢٠٠٤ المضي عل. بل لبولندا، اليابانية لها, التي الأمريكي بعض ثم.",
                    },
                ],
            },
            {
                id: "f3907983-9885-4211-8878-0f85750bbaa7",
                class: "columns-3-balanced",
                header: "الجهاز الهضمي الصحي",
                type: "articles-list",
                content: [
                    {
                        id: "d70c020f-dec2-4903-bba0-3b20bed16068",
                        title: "يخشى بعض المراهقين ، يا عزيزتي في أي رعاية.",
                        content:
                            "كلّ ماذا الشتوية اليابانية عن. الحكم المتّبعة ٣٠ فقد, ضرب واُسدل المسرح النزاع إذ, أي استرجاع الإيطالية ذلك. مما فكان أدنى أم, تحرّكت العسكري إذ بلا. ان لان قادة السفن النزاع, دنو بداية والمعدات ما. لها تجهيز إتفاقية كل, تعد وسوء والقرى ومطالبة بل. أعلنت العناد بالرغم لم كما.",
                    },
                    {
                        id: "b80ef050-df82-4ecb-ab98-d5311cae7a2a",
                        title: "استثمر تجمع الموجات فوق الصوتية للواجبات المنزلية ولكن.حتى لحوم البقر القطر.",
                        content:
                            "أن مكّن التقليدية دار, وتم حكومة ليركز عالمية ما, ثم الصعداء وانتهاءً حين. وصل الأجل بالمطالبة كل, لعملة الأوروبية، ومن ٣٠, ان وشعار اليابان الإتفاقية تحت. إذ تكبّد الجنوب على. دون مشارف ألمانيا الدّفاع ما, سقطت أدوات الثانية وقد أن.",
                    },
                    {
                        id: "bde5fc93-1779-4cf8-9d54-6ee9abfeb3c4",
                        title: "نطاق الألم ليس عنصرًا حاليًا من مضادات الأكسدة.",
                        content: "فقد إذ دفّة سليمان، ابتدعها, إذ أهّل حالية ايطاليا، أخذ. الوزراء والإتحاد كلّ من. لغزو لتقليعة البولندي ٣٠ قام. دنو وسوء واندونيسيا، عن, على ٣٠ وشعار وبالتحديد،.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-health-underscored",
        name: "يؤكد",
        articles: [
            {
                id: "851b619c-0d4b-478a-8991-d39394660b96",
                class: "columns-2-balanced",
                header: "هذا أولا",
                type: "grid",
                content: [
                    {
                        id: "fcf0478b-f9e9-4e2c-abbf-0d02de98e891",
                        image: {
                            src: "assets/images/drew-hays-tGYrlchfObE-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "بال قد والروسية الولايات. حاول وبعد ثانية ان الى, أواخر واتّجه بـ الى. أي أسر حقول استبدال, قد ودول الأجل هذا, جزيرتي وتنصيب التاريخ، عن الا. هو ومضى الدول للجزر فصل. تلك يطول أوروبا ثم, ما الدمج هاربر وبداية كلا, كل بال أخرى والديون الأبرياء.",
                        url: "#",
                    },
                    {
                        id: "ae54f79f-a7d7-4887-99eb-0e52720a5529",
                        image: {
                            src: "assets/images/hush-naidoo-jade-photography-Zp7ebyti3MU-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "قائمة الساحة وبالرغم من بعد. العالمي تشيكوسلوفاكيا أي على, الصفحات الأعمال الجنرال بـ يبق. تسمّى ليركز بها و, عن أسر وقبل الحرة. تمهيد إجلاء في ومن. عدم وانهاء بالرغم اليابان، أي, كما قامت الأرض بأيدي ثم.",
                        url: "#",
                    },
                ],
            },
            {
                id: "1080c9e5-4d40-4b28-9398-c03c9f94c74e",
                class: "columns-2-balanced",
                header: "هذا الثاني",
                type: "grid",
                content: [
                    {
                        id: "4bfb8bd6-9380-454d-9eae-17b6e6d311c8",
                        image: {
                            src: "assets/images/mathurin-napoly-matnapo-ejWJ3a92FEs-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "كسر",
                            },
                        },
                        text: "دار الدنمارك ولكسمبورغ بـ, تم بحث الإنزال الرئيسية. حصدت فرنسية المنتصر بحث ان. ان حالية الأولية دول, إعمار اتّجة جعل بل. لم وحتّى قائمة اعلان على. سليمان، التاريخ، مما مع. بخطوط وأزيز وبعدما أي الى, في خيار فبعد والفرنسي به،.",
                        url: "#",
                    },
                    {
                        id: "53270566-3767-47b9-8a1e-da8ccef49491",
                        image: {
                            src: "assets/images/national-cancer-institute-KrsoedfRAf4-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "كسر",
                            },
                        },
                        text: "لكل عن ألمانيا والروسية, بـ وكسبت الشرقي الخاطفة تحت. ٣٠ أضف أهّل الوراء الأوروبية, جيوب الوزراء سنغافورة أم انه, ليركز إبّان أم لها. ومن قد الأحمر محاولات وانتهاءً, لها من مشارف وبحلول لإنعدام. تم كان البرية المبرمة التبرعات. بلا بـ الغالي الثقيلة ولكسمبورغ. بمعارضة شموليةً و أضف, كما فكانت يتمكن وتنصيب بـ.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-health-what-to-eat",
        name: "ما الذي تريد أن تأكله",
        articles: [
            {
                id: "8ed51654-db6a-4826-bd1c-25213bc4200b",
                class: "columns-wrap",
                header: "الكربوهيدرات منخفضة",
                type: "excerpt",
                content: [
                    {
                        id: "342206b9-9843-477a-b4d0-48cd160b56b2",
                        image: {
                            src: "assets/images/kenny-eliason-5ddH9Y2accI-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "حدى عن يعبأ الفترة حاملات, وسوء الأثنان ثم انه, الى ان والقرى حاملات. قام ان تمهيد العناد بالتوقيع, ذلك بهيئة والمعدات بـ. جعل الشتاء الأوربيين هو, قدما تصرّف إبّان يتم ان, بـ كلّ أمدها كانتا المنتصر. ضرب عل سقوط المتساقطة،, لمّ و تصرّف الوراء بمحاولة. تسبب الأثناء، وصل ثم, بـ أعلنت والمانيا به،, حدى بمباركة الأسيوي التنازلي من.",
                    },
                    {
                        id: "61be9558-b680-4a9c-b9fe-f17a3f58ff53",
                        image: {
                            src: "assets/images/brigitte-tohm-iIupxcq-yH4-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "عن مكن لغات الإمداد, ٣٠ تلك مسرح الجنوبي, إذ الإكتفاء الأوربيين تلك. من مكن واتّجه والكوري عشوائية, بلاده بمباركة الرئيسية مع عدم. أراض ألمانيا عل مكن, بـ بداية الخاسر يبق. دون أي الأعمال الدّفاع والفلبين. بل عملية استرجاع تحت, ما مما مايو والتي الإقتصادي. مما من احداث اتفاق.",
                    },
                    {
                        id: "91414131-2202-462c-84b3-cbf6bf66fb34",
                        image: {
                            src: "assets/images/brooke-lark-oaz0raysASk-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "قام لم تغييرات الجنوبي. أم أراضي الثقيل نفس, جمعت السيء مع أخذ. إذ لان ويعزى الوراء ومطالبة, فعل بفرض حالية أطراف ما, تحرير يتعلّق ومطالبة عن تحت. دنو والحزب معاملة العمليات ما, في حتى هنا؟ بتحدّي, وأزيز وصافرات الصفحات على في. من بعد الأجل اليميني البولندي, هذا لعدم والإتحاد بالتوقيع مع. بالعمل الجنود إذ بحق.",
                    },
                ],
            },
            {
                id: "692a6213-1024-4d3e-8e6d-34aed2bb3616",
                class: "columns-wrap",
                header: "نباتي",
                type: "excerpt",
                content: [
                    {
                        id: "67db8a8e-9a39-4e2e-ba5a-7d57b0337fb0",
                        image: {
                            src: "assets/images/christina-rumpf-gUU4MF87Ipw-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "في ولم جمعت عشوائية. لان ماذا ٢٠٠٤ وفنلندا ثم. يتم جمعت وقبل اللا تم, كما وصغار السادس ان. فكان واستمر تعد بل. عن جديدة الساحل دنو. مما بل خطّة معزّزة الأوروبي, بداية وأزيز الخارجية وصل مع.",
                    },
                    {
                        id: "f045c26c-eaf6-4192-b022-f4c00014caa8",
                        image: {
                            src: "assets/images/nathan-dumlao-bRdRUUtbxO0-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "٣٠ كما أفاق والروسية الإقتصادية, أم مسرح وترك اسبوعين يتم, الا وبحلول يتعلّق ان. تصفح الخطّة الشتاء، في بين, عن الخاطفة الخارجية دار. ان ذلك زهاء مشروط. كلا مع قادة العظمى, كلا مليون وبالرغم بل, حدى و كردة بالعمل الفرنسي. يذكر الأراضي عن دول, ٣٠ لأداء اسبوعين ذلك, بال أثره، السيء إذ.",
                    },
                    {
                        id: "02cbeb30-a5f2-4465-9a85-ae00007fd71a",
                        image: {
                            src: "assets/images/maddi-bazzocco-qKbHvzXb85A-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "مكّن المدن لم جعل. بعد أم أدوات ويكيبيديا وبريطانيا. مع بعض الوزراء تشيكوسلوفاكيا, لم حول تونس الضغوط. بـ الحكم مهمّات بحق, سياسة بالعمل تم تحت. مساعدة وتنصيب ويكيبيديا كما أم, فعل بقصف المزيفة التقليدي من.",
                    },
                ],
            },
            {
                id: "f264a46c-4e7e-4c9f-bf04-d4ed1fa6639a",
                class: "columns-wrap",
                header: "إفطار",
                type: "excerpt",
                content: [
                    {
                        id: "719bbe3e-7a4b-4084-9bdd-8597a64d2c1c",
                        image: {
                            src: "assets/images/brooke-lark-IDTEXXXfS44-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "ما وقد كانت تسبب الإنذار،, اتّجة الاندونيسية بعض قد. تم الى عليها وسمّيت. عل لكون بالفشل عرض, اسبوعين والنرويج قد حول. بها الأمور رجوعهم الإمتعاض عل.",
                    },
                    {
                        id: "05d98dcf-d7e5-4819-b22d-8a289eec2b61",
                        image: {
                            src: "assets/images/joseph-gonzalez-QaGDmf5tMiE-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "هناك والمانيا الا مع. هو تلك تكبّد نتيجة ويتّفق, كانت الشرق، الرئيسية لكل كل. كل المبرمة الفرنسي ذات, زهاء الثالث وبولندا عرض و. ان تحت ليبين وبغطاء الهجوم. غضون الأرواح قُدُماً ٣٠ عدد, حتى مشارف والحزب أي. قائمة الأوربيين لمّ عل.",
                    },
                    {
                        id: "55d1073a-c733-4ca4-9ff1-e9ab2266ec84",
                        image: {
                            src: "assets/images/brooke-lark-GJMlSBS0FhU-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "وصغار أطراف أي ذات. هذه عن واحدة أوزار التخطيط, لم وجزر بالحرب مدن. لان ان ثانية والإتحاد. نهاية التقليدي حدى عل, مكن السيطرة الثالث، الأرضية لم.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-health-hot-topics",
        name: "مواضيع مثيرة",
        articles: [
            {
                id: "dde55759-06c6-46bc-9f16-bed37ae3d77f",
                class: "columns-2-balanced",
                header: "هذا أولا",
                type: "grid",
                content: [
                    {
                        id: "5e8ae348-e705-4be4-8e84-f09c3b2196dc",
                        image: {
                            src: "assets/images/national-cancer-institute-cw2Zn2ZQ9YQ-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "ان الجو للسيطرة الأثنان شيء. مما عن أدوات يتعلّق المنتصر, شاسعة الصين سنغافورة ولم ثم. بعض بقعة والحزب التجارية عن. فقد وإيطالي الشتاء، وايرلندا أن, من يطول فقامت الشتوية كلا, إذ كانتا اكتوبر أسر.",
                        url: "#",
                    },
                    {
                        id: "3ed555d2-4eb9-4263-84f8-8c7f973eae91",
                        image: {
                            src: "assets/images/national-cancer-institute-GcrSgHDrniY-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "مليارات الأراضي عن بعض. بال سقطت دأبوا من, أن بوابة بالسيطرة باستحداث كان. بعد لعدم بالولايات أم. احداث أعمال القوى أسر و.",
                        url: "#",
                    },
                ],
            },
            {
                id: "17f26d05-24ef-4a12-80b0-611a43449aae",
                class: "columns-2-balanced",
                header: "هذا الثاني",
                type: "grid",
                content: [
                    {
                        id: "60c6fd49-f5af-4313-af21-a83cea3ce371",
                        image: {
                            src: "assets/images/national-cancer-institute-SMxzEaidR20-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "كسر",
                            },
                        },
                        text: "حصدت وترك بقيادة ذلك أن, ذلك مايو فرنسية قد. حكومة وحلفاؤها الأوربيين بل مما, وفي عن هُزم بالفشل العالمية. المتحدة والمعدات من بعد, مدن من الصين الإقتصادي. تعد أي غريمه النفط استدعى, بل المارق الشهير العمليات قبل. لكون الشطر عدم أن, أخرى كُلفة إستعمل عن ومن, مع ضرب عقبت الهادي.",
                        url: "#",
                    },
                    {
                        id: "f4873b14-4600-429e-b239-708aac5872d5",
                        image: {
                            src: "assets/images/national-cancer-institute-L7en7Lb-Ovc-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "كسر",
                            },
                        },
                        text: "بعد كل انتباه بالرّغم بالولايات, مدن بـ وبعد إستعمل. مع العدّ استدعى الأمريكي وفي, بعض وقامت بتحدّي والعتاد في. وأزيز قائمة أم تحت. أمام وباءت مواقعها كل الى, حقول بخطوط بأضرار أي مكن. سكان استدعى ذات مع, وقد ٣٠ خيار الفترة الرئيسية, و أما اتفاق مكثّفة إستعمل.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-health-paid-content",
        name: "المحتوى المدفوع",
        articles: [
            {
                id: "cbaac182-d046-43ee-b6d7-41a382e959ad",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "c195937b-25a2-484b-8b0c-febfbae811b2",
                        image: {
                            src: "assets/images/dom-hill-nimElTcTNyY-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "سلطة كرة القدم حياة مجرد عملية الاحماء العظيمة.جعبة كبيرة واستثمر تصنيع تخرج.الراحة الإلزامية لا تتابع الذروة.",
                    },
                ],
            },
            {
                id: "ae883d3e-ef62-4f6e-ac2d-5555ca35f11a",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "c5808643-c726-4249-9b1d-270e18dcc84b",
                        image: {
                            src: "assets/images/sarah-dorweiler-gUPiTDBdRe4-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "مركبات في زيارة من دورة الحياة المدرسية.بالنسبة إلى أسهم عنصر الحياة في المنطقة والواجب المنزلي الأسد.لا احتياجات مطور التغذية ماليسوادا.",
                    },
                ],
            },
            {
                id: "d8f20994-0098-4367-bc3a-131faa8f768d",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "c27fac75-6c7c-4c26-9ac4-4f92c54e7308",
                        image: {
                            src: "assets/images/icons8-team-k5fUTay0ghw-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "إنها أتمنى أن ترغب في إزالة القوس الكراهية.جرة هي الآن الخوف.مطور الراحة الجامعي في في تمويل هو.في كرة السلة ، وقتي تمويل أي مطور التغذية.",
                    },
                ],
            },
            {
                id: "51f4b351-5916-4422-b661-61b65b911ee5",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "05b1ce25-c066-4b9e-8a44-7a25dac28759",
                        image: {
                            src: "assets/images/jessica-weiller-So4eFi-d1nc-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "كان التمويل ولكن الأداء ولكن البوابة.نولام ودرجة حرارة الحلق الفلفل الحار سعر المعرف السريري.الكتلة ليست واقعية الآن لعنصر المنطقة.",
                    },
                ],
            },
        ],
    },
];
